import { useNavigate } from 'react-router-dom'
import { SECTIONS } from '../../data/sections'
import type { SectionId, Category } from '../../types/tools'
import GrowthHouseLogo from '../base/GrowthHouseLogo'
import CategoryCard from './CategoryCard'
import MyTeamPanel from './MyTeamPanel'
import CommitmentsPanel from './CommitmentsPanel'

export default function Dashboard() {
  const navigate = useNavigate()

  const allCategories: Array<{
    sectionKey: SectionId
    categoryKey: string
    category: Category
  }> = []

  for (const sectionKey of Object.keys(SECTIONS) as SectionId[]) {
    const section = SECTIONS[sectionKey]
    for (const [categoryKey, category] of Object.entries(section.cats)) {
      allCategories.push({ sectionKey, categoryKey, category: category as Category })
    }
  }

  return (
    <div className="dash" data-testid="dashboard">
      {/* Growth House branding header */}
      <div className="dash-header" data-testid="dashboard-header">
        <GrowthHouseLogo size={56} />
        <div>
          <div className="dash-title">THE <span>GROWTH</span> HOUSE</div>
          <div className="dash-sub">Teamship Tools</div>
        </div>
      </div>

      <div className="dash-section" data-testid="dashboard-section">
        <div className="dash-sec-label" data-testid="dashboard-section-label">
          <span className="dash-sec-dot" style={{ background: 'var(--blue)' }} />
          Teamship Tools
        </div>
        <div className="dash-grid" data-testid="dashboard-grid">
          {allCategories.map(({ sectionKey, categoryKey, category }, index) => (
            <CategoryCard
              key={categoryKey}
              categoryKey={categoryKey}
              category={category}
              cardNumber={index + 1}
              onClick={() => navigate(`/category/${sectionKey}/${categoryKey}`)}
            />
          ))}
        </div>
      </div>

      <MyTeamPanel />

      <CommitmentsPanel />
    </div>
  )
}
